document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-scc-name-input]').forEach(function (input) {
    if (input.dataset.sccPreviewBound) return;
    input.dataset.sccPreviewBound = 'true';
    var targetSel = input.getAttribute('data-scc-name-input');
    var target = document.querySelector(targetSel);
    if (!target) return;
    var defaultText = target.getAttribute('data-default') || 'Your Name';
    input.addEventListener('input', function () {
      target.textContent = input.value.trim() ? input.value : defaultText;
    });
  });

  document.querySelectorAll('[data-scc-reviews-toggle]').forEach(function (btn) {
    if (btn.dataset.sccReviewsBound) return;
    btn.dataset.sccReviewsBound = 'true';
    var wrapSel = btn.getAttribute('data-scc-reviews-toggle');
    var wrap = document.querySelector(wrapSel);
    if (!wrap) return;
    var moreLabel = btn.getAttribute('data-label-more') || 'Show More Reviews';
    var lessLabel = btn.getAttribute('data-label-less') || 'Show Less';
    btn.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      wrap.querySelectorAll('[data-scc-extra-review]').forEach(function (card) {
        card.hidden = !expanded;
      });
      btn.textContent = expanded ? lessLabel : moreLabel;
    });
  });

  document.querySelectorAll('.scc-faq-item__q').forEach(function (btn) {
    if (btn.dataset.sccFaqBound) return;
    btn.dataset.sccFaqBound = 'true';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var item = btn.closest('.scc-faq-item');
      var wasOpen = item.classList.contains('is-open');
      item.closest('.scc-faq__inner').querySelectorAll('.scc-faq-item').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.scc-faq-item__q').setAttribute('aria-expanded', 'false');
        var sym = el.querySelector('.scc-faq-item__sym');
        if (sym) sym.textContent = '+';
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        var sym = item.querySelector('.scc-faq-item__sym');
        if (sym) sym.textContent = '−';
      }
    });
  });

  document.querySelectorAll('video.scc-hero__video').forEach(function (video) {
    video.muted = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  });
});
